<div fxFlex fxLayout="column" fxLayoutGap="1rem">
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{ 'departments.departments' | translate }}</span>
      <button mat-raised-button *ngxPermissionsOnly="['ROLE_SUPER_ADMIN']" color="primary" (click)="editDepartment()">
        <mat-icon>add</mat-icon>
        {{ 'departments.actions.create' | translate }}
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-card appearance="outlined" fxFlex="grow" fxLayout="column">
    <table mat-table [dataSource]="(departments$ | async) ?? []" class="main-content" #departmentsTable>
      <ng-container matColumnDef="sortOrder">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.sortOrder' | translate }}</th>
        <td mat-cell *matCellDef="let department">{{ department.sortOrder }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.name' | translate }}</th>
        <td mat-cell *matCellDef="let department">{{ department.name }}</td>
      </ng-container>

      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.color' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          <span class="color-preview" [style.background-color]="department.color"></span>
          {{ department.color }}
        </td>
      </ng-container>

      <ng-container matColumnDef="opacity">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.opacity' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          <span
            class="opacity-preview"
            [style.background-color]="department.color"
            [style.opacity]="department.opacity / 100"
          ></span>
          {{ department.opacity }} %
        </td>
      </ng-container>

      <ng-container matColumnDef="people">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.people' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          {{ department.activeDriverCount }}
          @if (department.inactiveDriverCount > 0) {
            <span class="inactive-count">
              ({{ 'departments.inactivePeople' | translate: { count: department.inactiveDriverCount } }})
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="vehicles">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.vehicles' | translate }}</th>
        <td mat-cell *matCellDef="let department">
          {{ department.activeVehicleCount }}
          @if (department.inactiveVehicleCount > 0) {
            <span class="inactive-count">
              ({{ 'departments.inactiveVehicles' | translate: { count: department.inactiveVehicleCount } }})
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="holds">
        <th mat-header-cell *matHeaderCellDef>{{ 'departments.holds' | translate }}</th>
        <td mat-cell *matCellDef="let department" class="holds-column">
          @if (department.canHoldDrivers) {
            <mat-icon class="material-icons" [matTooltip]="'departments.people' | translate">person</mat-icon>
          }
          @if (department.canHoldVehicles) {
            <mat-icon class="material-icons" [matTooltip]="'departments.vehicles' | translate">local_shipping</mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'core.actions' | translate }}</th>
        <td mat-cell *matCellDef="let department" class="actions-column">
          <mat-menu #departmentActions>
            <button mat-menu-item (click)="editDepartment(department['@id'])">
              {{ 'departments.actions.edit' | translate }}
            </button>
            <button
              mat-menu-item
              [disabled]="!canBeDeleted(department)"
              [matTooltip]="canBeDeleted(department) ? '' : ('departments.deleteBlocked' | translate)"
              (click)="deleteDepartment(department['@id'])"
            >
              {{ 'departments.actions.delete' | translate }}
            </button>
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="departmentActions">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let department; columns: tableColumns"></tr>
    </table>

    @if (actionPending$ | async) {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    }
  </mat-card>
</div>
